import { Component } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';

@Component({
	selector: 'app-contacts-destiny',
	templateUrl: './contacts-destiny.component.html',
	styleUrls: ['./contacts-destiny.component.css'],
})
export class ContactsDestinyComponent extends ShowComponent {
	protected apiType = 'bag';
	protected apiUrlAdd = '/contacts_destiny/';
	protected parentComponent = 'codebook/contacts_destiny';
	parentLocationSet = [];
	protected itemsBeforeDataLoad = 2;
	codebook;

	protected pageTitleGenerate(): string {
		return `Słowniki ->  
			${this.codebook.name} 
			 ->  
			${this.data.destiny}
			 (ID:  
			${this.data.id}
			)`;
	}

	data = {
		id: null,
		destiny: null,
	};

	protected loadBefore(): void {
		this.bag.get('/contacts_destiny/', (result, error) => {
			this.parentLocationSet = result.results;
			this.loadData();
		});
		this.bag.get('/codebook/11/', (result, error) => {
			this.codebook = result;

			this.loadData();
		});
	}

	protected submitAfter(): void {
		this.router.navigate([this.parentComponent]);
	}

	protected getApiUrl(): string {
		return '/contacts_destiny/' + this.data.id + '/';
	}
}
